import React from 'react'
import '../../assets/stylesheets/subscribe.css'
import { useSubscription, useStripeIntegration } from './hooks'
import {
  ProductDisplayWithHeader,
  ManageSubscription,
  SubscriptionMessage
} from './components'

export default function Subscribe() {
  const { userId, stripeCustomerId, hasActiveSubscription } = useSubscription()
  const { message } = useStripeIntegration()

  if (!hasActiveSubscription && message === '') {
    return <ProductDisplayWithHeader userId={userId} />
  } else if (hasActiveSubscription) {
    return <ManageSubscription stripeCustomerId={stripeCustomerId} />
  } else {
    return <SubscriptionMessage message={message} />
  }
}
